import { FC, ReactNode, useMemo } from 'react'
import classnames from 'classnames'
import { isPresent } from 'utils'

interface RowProps {
  children?: ReactNode;
  className?: string;
}

const Row: FC<RowProps> = ({
  children,
  className,
}) => {
  const classes = useMemo(() => classnames({
    'row': true,
    [className || '']: isPresent(className),
  }), [className])

  return (
    <div className={classes}>
      {children}
    </div>
  )
}

export default Row
